export const LEGACY_PASTURE_STATE_MAP = {
    Grazing: 'Livestock',
    Hay: 'Cropping',
    Resting: 'Non-Agricultural',
    Cropping: 'Cropping',
    Livestock: 'Livestock',
    'Non-Agricultural': 'Non-Agricultural',
}

export const PADDOCK_PASTURE_STATES = [
    { state: 'livestock', value: 'Livestock', color: '#32CD32B3', faIcon: 'fad fa-sheep', t: '2637' },
    { state: 'cropping', value: 'Cropping', color: '#FFD700B3', faIcon: 'fad fa-tractor', t: '2883' },
    { state: 'non-agricultural', value: 'Non-Agricultural', color: '#A9A9A9B3', faIcon: 'fad fa-campground', t: '5383' },
]

export function migratePastureState(value) {
    if (value == null || value === '') return value
    return LEGACY_PASTURE_STATE_MAP[value] ?? value
}

export function migratePaddockRecords(records) {
    if (!records?.length) return records
    return records.map(r => {
        if (r?.type !== 'pastureStateChange') return r
        const next = { ...r, new: r.new ? { ...r.new } : r.new }
        if (next.new?.pastureState != null) next.new.pastureState = migratePastureState(next.new.pastureState)
        if (next.old?.pastureState != null) next.old = { ...next.old, pastureState: migratePastureState(next.old.pastureState) }
        return next
    })
}

export function pastureStateToTranslationKey(pastureState) {
    const match = PADDOCK_PASTURE_STATES.find(s => s.value === pastureState)
    return match?.t ?? null
}
